import {
  ChangelogCategorySection,
  ChangelogEntries,
  splitByCategory,
} from '@reflex/ui/components/content/ChangelogEntry';
import type { VersionReleasePayload } from '../../../shared/types.js';

export interface VersionReleaseRendererProps {
  payload: VersionReleasePayload;
}

/**
 * Renders a legacy version-release notification with the same treatment as the
 * releases page: accent-colored category labels ("Features", "Bug Fixes"),
 * entries badged by product area, PR/commit references stripped.
 *
 * `payload.changelogUrl` (the in-app `/changelog#v<version>` route) is
 * intentionally not rendered: that page is generated from a private repo, so
 * the link out is hidden for now. The field stays on the payload — it is
 * persisted on existing notifications — for when it comes back.
 */
export function VersionReleaseRenderer({ payload }: VersionReleaseRendererProps) {
  const categories = splitByCategory(payload.summary);

  return (
    <div className="space-y-6" data-testid="notification-renderer-version-release">
      {categories.length > 0 && categories[0].name !== '' ? (
        <div className="space-y-6">
          {categories.map((cat) => (
            <ChangelogCategorySection key={cat.name} name={cat.name}>
              <ChangelogEntries content={cat.content} />
            </ChangelogCategorySection>
          ))}
        </div>
      ) : (
        <ChangelogCategorySection name="">
          <ChangelogEntries content={payload.summary} />
        </ChangelogCategorySection>
      )}
    </div>
  );
}
